type ExecutionMetricSeries = {
  frequencyPerDay: number[];
};

export const resolveLatestSeriesIndex = (metricSeries?: ExecutionMetricSeries): number | null => {
  if (!metricSeries) return null;
  for (let index = metricSeries.frequencyPerDay.length - 1; index >= 0; index -= 1) {
    if (metricSeries.frequencyPerDay[index] > 0) return index;
  }
  return null;
};

export const resolveSeriesValue = (
  values: number[] | undefined,
  index: number | null,
): number | null => {
  if (index === null || !values) return null;
  if (index < 0 || index >= values.length) return null;
  return values[index];
};
